import { Star } from 'lucide-react';
import { cn } from '../utils/cn';

interface StarRatingProps {
  rating: number;
  max?: number;
  size?: number;
  className?: string;
}

export default function StarRating({ rating, max = 5, size = 16, className }: StarRatingProps) {
  return (
    <div className={cn('flex items-center gap-0.5', className)}>
      {Array.from({ length: max }, (_, i) => {
        const filled = i < Math.floor(rating);
        const half = !filled && i < rating;
        return (
          <Star
            key={i}
            size={size}
            className={cn(
              filled ? 'fill-warning text-warning' : half ? 'fill-warning/50 text-warning' : 'text-content-muted'
            )}
          />
        );
      })}
    </div>
  );
}
